import { render, staticRenderFns } from "./ExchangeForm.vue?vue&type=template&id=b8775bc0&scoped=true&"
import script from "./ExchangeForm.vue?vue&type=script&lang=js&"
export * from "./ExchangeForm.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeForm.vue?vue&type=style&index=0&id=b8775bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8775bc0",
  null
  
)

export default component.exports